import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getVoucher,
  getVoucherById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  createVoucher,
  updateVoucher,
  approveVoucher,
} from "./thunk";

const initialState = {
  vouchers: [],
  edit: false,
  voucher: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingVoucher: false,
  loadingNext: false,
  loadingDetails: false,
  saveAndContinue: false,
  loadingApprove: false,
  voucherDetails: [
    {
      account: null,
      drAmount: "",
      crAmount: "",
      checkNo: "",
      costCenterDetail: "",
      unique: uuidv4(),
    },
  ],
  showCreateModal: false,
};

export const voucherSlice = createSlice({
  name: "voucher",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    voucherDetailsUpdated: (state, action) => {
      state.voucherDetails = action.payload;
    },
    clearVoucherDetails: (state) => {
      state.voucherDetails = [
        {
          account: null,
          drAmount: "",
          crAmount: "",
          checkNo: "",
          costCenterDetail: "",
          unique: uuidv4(),
        },
      ];
    },
    clearAllVoucher: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingVoucher = false;
      state.voucher = null;
      state.saveAndContinue = false;
      state.voucherDetails = [
        {
          account: null,
          drAmount: "",
          crAmount: "",
          checkNo: "",
          costCenterDetail: "",
          unique: uuidv4(),
        },
      ];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createVoucher.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createVoucher.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(createVoucher.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(updateVoucher.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateVoucher.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.voucher = action.payload.data;
      state.voucherDetails = action.payload.data?.voucherDetails?.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(updateVoucher.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(approveVoucher.pending, (state) => {
      state.loadingApprove = true;
    });
    builder.addCase(approveVoucher.fulfilled, (state, action) => {
      state.loadingApprove = false;
      state.voucher = action.payload.data;
      state.voucherDetails = action.payload.data?.voucherDetails?.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(approveVoucher.rejected, (state) => {
      state.loadingApprove = false;
    });
    // getVoucherById
    builder.addCase(getVoucherById.pending, (state) => {
      state.loading = true;
      state.voucher = null;
    });
    builder.addCase(getVoucherById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.voucher = action.payload.data;
      state.voucherDetails = action.payload.data?.voucherDetails?.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getVoucherById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
    });
    builder.addMatcher(
      isAnyOf(
        getVoucher.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingVoucher = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getVoucher.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingVoucher = false;
        state.vouchers = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getVoucher.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingVoucher = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  voucherDetailsUpdated,
  clearVoucherDetails,
  clearAllVoucher,
} = voucherSlice.actions;

export default voucherSlice.reducer;
